import React, { Fragment } from "react";
import { compose } from "recompose";
import { Input } from "antd";
import { withTranslation } from "react-i18next";

import { Field } from "../../components/controls/FormikForm";

const TeamDetailsForm = ({ t }) => (
  <Fragment>
    <Field name="name" label={t("team:name")}>
      <Input />
    </Field>
  </Fragment>
);

export default compose(withTranslation(["team"]))(TeamDetailsForm);
